import { c as _c } from "react/compiler-runtime";
import { useLoyaltyContext, useUserSession } from '@libs/common-next';
import { CurrentTierLevel } from '@libs/common-types';
import { invariant } from '@libs/core';
type UseAccountAuthenticated = {
  loyaltyData: {
    availableDollars: string;
    availablePoints: string;
    currentTierLevel: CurrentTierLevel;
  } | null;
  firstName: string;
};
function formatPoints(points: number) {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0
  }).format(points);
}
export function useAccountAuthenticated() {
  const $ = _c(13);
  const {
    memberPoints,
    isLoyaltyUnavailable
  } = useLoyaltyContext();
  const {
    userData
  } = useUserSession();
  const profile = userData?.profile;
  invariant(profile, "Authenticated account requires a profile");
  const {
    firstName
  } = profile;
  if (isLoyaltyUnavailable || !memberPoints) {
    let t0;
    if ($[0] !== firstName) {
      t0 = {
        loyaltyData: null,
        firstName
      };
      $[0] = firstName;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  const {
    availableDollars,
    availablePoints,
    currentTierLevel
  } = memberPoints;
  let t0;
  if ($[2] !== availableDollars) {
    t0 = availableDollars.toFixed(2);
    $[2] = availableDollars;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== availablePoints) {
    t1 = formatPoints(availablePoints);
    $[4] = availablePoints;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== currentTierLevel || $[7] !== t0 || $[8] !== t1) {
    t2 = {
      availableDollars: t0,
      availablePoints: t1,
      currentTierLevel
    };
    $[6] = currentTierLevel;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== firstName || $[11] !== t2) {
    t3 = {
      loyaltyData: t2,
      firstName
    };
    $[10] = firstName;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}